import React, { useEffect } from 'react';
import { matchPath, useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/store/hooks';
import { fetchServers } from 'src/actions/mine_craft/serversActions';
import minecraftUrls from 'src/configs/mine_craft/minecraftUrls';
import { queryParams } from "src/helpers/UrlHelpers";

import PageHeader from './_partials/_PageHeader';
import PageLayout from '../_partials/PageLayout';
import List from "./_partials/_List";
import Edit from "./Edit";
import New from "./New";
import Wrapper from "src/componets/Wrapper";
import NavBarThree from "src/componets/NavBarThree";
import Filter from "src/componets/Filter";
import Can from "src/componets/Can";
import './style.scss';
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "src/store/mine_craft/serversSlice";

const LIMIT = 42;
const KINDS: any = {
  'all': {
    name: 'All'
  },
  'user': {
    name: 'User'
  },
  'official': {
    name: 'Official'
  }
};
const KIND_IDS = Object.keys(KINDS);

export interface PropsInterface {
  appId: 1 | 2;
}

const Servers = ({ appId }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const kindId = queryParams.get(searchParams, 'kind');
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();
  const isUnpublished = !!matchPath(minecraftUrls.serversUnpublishedPath(), pathname);
  const orderByFilter = {
    items: [
      { name: 'Date', key: 'id' },
      { name: 'Popular', key: 'popular_count' },
      { name: 'Likes', key: 'likes_count' },
      { name: 'Comments', key: 'comments_count' },
    ]
  };

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (kindId) {
      params.kind = kindId;
    }

    if (isUnpublished) {
      params.state = 'unpublished';
    }

    dispatch(fetchServers(params));
  }, [searchParams, appId, pathname, kindId, isUnpublished, currentPage, dispatch]);

  const isActive = (id: string | undefined) => {
    if (isUnpublished) {
      return '';
    }

    return (!kindId && id === 'all') || kindId === id ? 'active' : '';
  }

  const renderFilterItem = (id: any) => {
    const item = KINDS[id];
    const linkParams = id === 'all' ? minecraftUrls.serversPath() : `${minecraftUrls.serversPath()}?kind=${id}`;

    return (
      <NavBarThree.Link
        key={id}
        className={isActive(id)}
        to={linkParams}
      >
        {item.name}
      </NavBarThree.Link>
    )
  }

  function onClickCreate() {
    dispatch(setNewParams({ app_id: appId }));
  }

  return (
    <PageLayout>
      <PageHeader />

      <Wrapper className='v-wrapper__between'>
        <NavBarThree type='type1'>
          {KIND_IDS.map(renderFilterItem)}

          <NavBarThree.Link
            key='unpublished'
            className={isUnpublished ? 'active' : ''}
            to={minecraftUrls.serversUnpublishedPath()}
          >
            Unpublished
          </NavBarThree.Link>
        </NavBarThree>

        <Can capability='write_minecraft'>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Server
          </NavBarThree.Button>
        </Can>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={orderByFilter}
          />
        </Wrapper>

        <List limit={LIMIT} />
      </div>

      <Edit />
      <New />
    </PageLayout>
  );
}

export default Servers;
